<template>
    <div class="form-group row align-items-center">
        <label class="col-md-2 mb-md-0"> {{ $t('phone') }} </label>
        <app-input 
            class="col-md-8" 
            type="tel-input" 
            v-model="selected" 
            min="6"
            :placeholder="$t('phone')" 
        />
    </div>
</template>
 
<script>
    export default {
        name: 'CustomerPhone',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>